// components/Upcoming3Section1.jsx
import React from 'react';
import Navbar2 from '../../Navbar/Navbar2/Navbar2';
import Footer from '../../Footer/Footer';
import { LuLightbulb, LuEye, LuThermometer, LuBrain, LuCpu, LuWifi, LuPlane, LuDatabase, LuNetwork } from 'react-icons/lu';
import './Upcoming3.css';



const Upcoming3 = ({ onNavigate }) => {
    const steps = [
        {
          number: '1',
          title: 'Vision Engine',
          description: 'Computer vision interprets analogue flowmeter readings',
        },
        {
          number: '2',
          title: 'Thermal Capture',
          description: 'Thermal imaging overlays capture fuel temperature',
        },
        {
          number: '3',
          title: 'AI Processing',
          description: 'Algorithm combines data for precise mass flow calculation',
        },
        {
          number: '4',
          title: 'Digital Output',
          description: 'Real-time digital mass flow data with audit trails',
        },
      ];


  return (
    <>
      <Navbar2 onNavigate={onNavigate} />

      {/* SECTION 1 */}
      <div className="massflow-section">
        <h1 className="massflow-title">
          Shipshape Vision Mass Flow Reader<span className="superscript">™</span>
        </h1>
        {/* <h2 className="massflow-subtitle">
          AI-Powered Fuel Mass Flow Measurement — No Retrofitting. No Downtime.
        </h2>
        <p className="massflow-description">
          Transform your existing analogue flowmeters into accurate digital mass flow sensors without
          vessel stoppage or invasive modifications.
        </p> */}
        <h2 className="massflow-subtitle">
          AI-Powered Fuel Analytics & Performance Intelligence
        </h2>
        <p className="massflow-description">
        Transform fuel and operational data into actionable insights that improve efficiency, support emissions reporting, and optimize fleet performance.
        </p>
                    <button className="massflow-button" onClick={() => onNavigate('contact')}>Book Demo</button>
      </div>

      {/* SECTION 2 */}
      {/* <section className="retrofit-v2-section">
  <h2 className="retrofit-v2-title">Revolutionary Retrofit Solution</h2>
  <p className="retrofit-v2-description">
    Shipshape Vision Mass Flow Reader<span className="retrofit-v2-superscript">™</span> leverages AI-based computer vision, thermal scanning,
    and optional autonomous drone deployment to deliver real-time, temperature-corrected fuel
    mass flow data.
  </p>

  <div className="retrofit-v2-cards">
    <div className="retrofit-v2-card">
      <LuEye className="retrofit-v2-icon" />
      <h3 className="retrofit-v2-card-title">Computer Vision</h3>
      <p className="retrofit-v2-card-text">
        AI interprets readings from analogue flowmeter dials (rotary or linear) with precision.
      </p>
    </div>

    <div className="retrofit-v2-card">
      <LuThermometer className="retrofit-v2-icon" />
      <h3 className="retrofit-v2-card-title">Thermal Analysis</h3>
      <p className="retrofit-v2-card-text">
        Thermal imaging captures accurate fuel temperature for density correction.
      </p>
    </div>

    <div className="retrofit-v2-card">
      <LuBrain className="retrofit-v2-icon" />
      <h3 className="retrofit-v2-card-title">AI Algorithm</h3>
      <p className="retrofit-v2-card-text">
        Combines flow and temperature data to deliver precise digital mass flow readings.
      </p>
    </div>
  </div>
</section>


      <section className="how-it-works-section">
      <h2 className="how-title">How It Works</h2>
      <p className="how-subtitle">
        A seamless integration process that transforms analog systems into smart digital solutions.
      </p>
      <div className="how-cards-container">
        {steps.map((step, index) => (
          <div className="how-card" key={index}>
            <div className="circle">{step.number}</div>
            <h3 className="step-title">{step.title}</h3>
            <p className="step-description">{step.description}</p>
          </div>
        ))}
      </div>
    </section> */}
    <section className="retrofit-v2-section">
  <h2 className="retrofit-v2-title">AI-Powered Fuel Intelligence</h2>
  <p className="retrofit-v2-description">
  Shipshape Vision<span className="retrofit-v2-superscript">™</span> leverages advanced analytics, machine learning, and maritime domain expertise to transform fuel and operational data into actionable intelligence for efficiency, compliance, and performance improvement.
  </p>

  <div className="retrofit-v2-cards">
    <div className="retrofit-v2-card">
      <LuEye className="retrofit-v2-icon" />
      <h3 className="retrofit-v2-card-title">AI-Driven Insights</h3>
      <p className="retrofit-v2-card-text">
      Apply machine learning and predictive analytics to uncover inefficiencies, detect anomalies, and support data-driven operational decisions.
      </p>
    </div>

    <div className="retrofit-v2-card">
      <LuThermometer className="retrofit-v2-icon" />
      <h3 className="retrofit-v2-card-title">Fuel Performance Analytics</h3>
      <p className="retrofit-v2-card-text">
      Analyze fuel consumption patterns, operational trends, and performance metrics to identify opportunities for efficiency improvements.
      </p>
    </div>

    <div className="retrofit-v2-card">
      <LuBrain className="retrofit-v2-icon" />
      <h3 className="retrofit-v2-card-title">Compliance Intelligence</h3>
      <p className="retrofit-v2-card-text">
      Support FuelEU Maritime, EU ETS, MRV, and CII initiatives with accurate reporting, monitoring, and decision-support insights.
      </p>
    </div>
  </div>
</section>


      <section className="how-it-works-section">
      <h2 className="how-title">How It Works</h2>
      <p className="how-subtitle">
        A seamless integration process that transforms analog systems into smart digital solutions.
      </p>
      <div className="how-cards-container">
        {steps.map((step, index) => (
          <div className="how-card" key={index}>
            <div className="circle">{step.number}</div>
            <h3 className="step-title">{step.title}</h3>
            <p className="step-description">{step.description}</p>
          </div>
        ))}
      </div>
    </section>


{/* ---------------------------- */}

<section className="benefits-section">
  <h2 className="benefits-title">Key Benefits</h2>
  <p className="benefits-subtitle">
    Achieve compliance and cost savings without operational disruption.
  </p>
  <div className="benefits-grid">
    <div className="benefit-item">
      <h3>Accurate Fuel Mass Flow</h3>
      <p>Without replacing existing flowmeters</p>
    </div>
    <div className="benefit-item">
      <h3>Zero Downtime</h3>
      <p>No drydock or system disruption required</p>
    </div>
    <div className="benefit-item">
      <h3>Cost Savings</h3>
      <p>Avoids $15k–$50k+ flowmeter retrofits</p>
    </div>
    <div className="benefit-item">
      <h3>Universal Compatibility</h3>
      <p>Works with any engine room configuration</p>
    </div>
    <div className="benefit-item">
      <h3>Edge AI Enabled</h3>
      <p>No cloud dependency onboard</p>
    </div>
    <div className="benefit-item">
      <h3>Patent Pending</h3>
      <p>Long-term defensibility and innovation</p>
    </div>
  </div>
</section>

{/* SECTION 5 - WHY IT MATTERS */}
{/* <section className="matters-section">
  <div className="matters-container">
    <div className="matters-left">
      <h2 className="matters-title">Why It Matters</h2>
      <ul className="matters-points">
        <li><strong>Volume-based readings</strong> ignore fuel density/temperature variation</li>
        <li><strong>Manual reading</strong> introduces human error and cannot meet compliance requirements</li>
        <li><strong>Retrofitting</strong> requires cutting pipelines, stopping operations, or docking</li>
      </ul>
    </div>
    <div className="matters-right">
      <div className="matters-box">
        <h3>Shipshape Solution</h3>
        <p>
          <strong>Shipshape Vision Mass Flow Reader™</strong> enables smart fuel accounting and emissions
          reporting—without any of those hurdles.
        </p>
        <div className="badge-row">
          <span className="badge">EU ETS Compliant</span>
          <span className="badge">MRV Ready</span>
          <span className="badge">FuelEU Maritime</span>
        </div>
      </div>
    </div>
  </div>
</section> */}
<section className="matters-section">
  <div className="matters-container">
    <div className="matters-left">
      <h2 className="matters-title">Why It Matters</h2>
      <ul className="matters-points">
        <li><strong>Fragmented data sources</strong> create reporting gaps and operational blind spots</li>
        <li><strong>Manual data collection</strong> and spreadsheet-based processes increase risk, effort, and reporting inaccuracies</li>
        <li><strong>Disconnected systems</strong> make it difficult to gain timely operational and compliance insights</li>
      </ul>
    </div>
    <div className="matters-right">
      <div className="matters-box">
        <h3>Shipshape Solution</h3>
        <p>
          <strong>Shipshape Vision™</strong> simplifies fuel performance monitoring, emissions reporting, and compliance management through advanced analytics and automation.
        </p>
        <div className="badge-row">
          <span className="badge">EU ETS Compliant</span>
          <span className="badge">MRV Ready</span>
          <span className="badge">FuelEU Maritime</span>
        </div>
      </div>
    </div>
  </div>
</section>



{/* SECTION 6 - USE CASES */}
<section className="usecases-section">
  <h2 className="usecases-title">Use Cases</h2>
  <p className="usecases-subtitle">
    Versatile applications across maritime operations and compliance requirements.
  </p>

  <div className="usecases-grid">
    {[
      {
        title: "Bunker Monitoring",
        desc: "Track fuel intake and consumption with precision for cost control.",
      },
      {
        title: "Engine System Monitoring",
        desc: "Monitor Main/Aux Engine and Boiler fuel systems in real-time.",
      },
      {
        title: "Compliance Reporting",
        desc: "Meet MRV, EU ETS, and FuelEU Maritime mass-based requirements.",
      },
      {
        title: "Dispute Resolution",
        desc: "Charter-party dispute resolution with time-stamped audit trails.",
      },
      {
        title: "Cost Attribution",
        desc: "Accurate cost attribution and emissions forecasting capabilities.",
      },
      {
        title: "Fleet Maintenance",
        desc: "Fleet-wide condition-based maintenance optimization.",
      },
    ].map((usecase, i) => (
      <div className="usecase-card" key={i}>
        <h3 className="usecase-title">{usecase.title}</h3>
        <p className="usecase-desc">{usecase.desc}</p>
      </div>
    ))}
  </div>
</section>



{/* SECTION 7 - TECHNOLOGY STACK */}
{/* <section className="techstack-section">
  <h2 className="techstack-title">Technology Stack</h2>
  <p className="techstack-subtitle">
    World-first hybrid retrofit system integrating cutting-edge technologies.
  </p>

  <div className="techstack-grid">
    {[
      {
        title: "AI Vision Module",
        desc: "Analog dial recognition with machine learning",
        icon: <LuEye />
      },
      {
        title: "Thermal Sensor Unit",
        desc: "Live temperature acquisition for accuracy",
        icon: <LuThermometer />
      },
      {
        title: "Inference Engine",
        desc: "Offline processing with edge computing",
        icon: <LuCpu />
      },
      {
        title: "Drone Integration",
        desc: "Optional swarm deployment architecture",
        icon: <LuPlane />
      },
    ].map((item, i) => (
      <div className="tech-card" key={i}>
        <div className="tech-icon">{item.icon}</div>
        <h3 className="tech-title">{item.title}</h3>
        <p className="tech-desc">{item.desc}</p>
      </div>
    ))}
  </div>
</section> */}
<section className="techstack-section">
  <h2 className="techstack-title">Technology Stack</h2>
  <p className="techstack-subtitle">
     Advanced AI, analytics, and data-processing technologies powering maritime intelligence.
  </p>

  <div className="techstack-grid">
    {[
      {
        title: "AI Vision Module",
        desc: "Machine learning models for anomaly detection, performance analysis, and operational intelligence",
        icon: <LuEye />
      },
      {
        title: "Data Processing Layer",
        desc: "Aggregates and standardizes operational, voyage, fuel, and emissions data for advanced analytics",
        icon: <LuDatabase />
      },
      {
        title: "Intelligence Engine",
        desc: "AI-powered analysis, forecasting, benchmarking, and decision-support capabilities",
        icon: <LuCpu />
      },
      {
        title: "Integration Framework",
        desc: "Secure APIs and flexible connectivity with fleet management, voyage optimization, and compliance platforms",
        icon: <LuNetwork />
      },
    ].map((item, i) => (
      <div className="tech-card" key={i}>
        <div className="tech-icon">{item.icon}</div>
        <h3 className="tech-title">{item.title}</h3>
        <p className="tech-desc">{item.desc}</p>
      </div>
    ))}
  </div>
</section>



{/* SECTION 8 - FINAL CTA */}
<section className="final-cta-section">
  <h2 className="final-cta-title">
    Start Measuring What Matters—Without<br />Stopping the Ship
  </h2>
  <p className="final-cta-subtitle">
    Retrofitting mass flow measurement doesn't have to mean downtime. Get real-time, compliant, cost-saving fuel intelligence—today.
  </p>
              <button className="final-cta-button" onClick={() => onNavigate('contact')}>Schedule Demo</button>
</section>




      <Footer onNavigate={onNavigate} />
    </>
  );
};

export default Upcoming3;
